import styled from 'styled-components'
import getBreakpoint from '@client/utils/breakpoints'

import Image from '@components/Image'

const ClickableArea = styled.a`
  text-decoration: none;
`

const MainPanel = styled.div`
  width: 100%;
  height: 124px;
  background: #ffffff;
  box-shadow: 0px 2px 6px rgba(152, 152, 167, 0.25);
  border-radius: 4px;
  @media (min-width: ${getBreakpoint('xl')}px) {
    width: 288px;
  }
`

const Photo = styled(Image)`
  width: 104px;
  height: 124px;
`

const Text = styled.div`
  display: block;
`

const Title = styled.div`
  display: block;
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #000000;
  margin-top: 16px;
  margin-left: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
  @media (min-width: ${getBreakpoint('xl')}px) {
    max-width: 165px;
  }
`

const Activities = styled.div`
  display: block;
  margin-left: 16px;
  margin-top: 20px;
  color: #666666;
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
  @media (min-width: ${getBreakpoint('xl')}px) {
    max-width: 165px;
  }
`

const RatingWrapper = styled.div`
  display: flex;
  margin-top: 12px;
  margin-left: 16px;
`

const RatingText = styled.div`
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;

  color: #666666;
  margin-left: 4.5px;
`

export {
  ClickableArea,
  MainPanel,
  Photo,
  Text,
  Title,
  Activities,
  RatingWrapper,
  RatingText,
}
